import LinkIcon from './component-lib.esm26.js';
import EmbedOutlineIcon from './component-lib.esm65.js';
import DynamicFormIcon from './component-lib.esm73.js';
import RssIcon from './component-lib.esm53.js';
import EmailIcon from './component-lib.esm23.js';
import PhoneIcon from './component-lib.esm68.js';
import TitleIcon from './component-lib.esm55.js';
import CarouselIcon from './component-lib.esm37.js';
import MinusIcon from './component-lib.esm51.js';
import GroupIcon from './component-lib.esm106.js';
import TextBoxOutlineIcon from './component-lib.esm98.js';
import CardAccountDetailsOutlineIcon from './component-lib.esm95.js';
import DonationIcon from './component-lib.esm86.js';
import RequestIcon from './component-lib.esm82.js';
import GridIcon from './component-lib.esm96.js';
import ShopIcon from './component-lib.esm109.js';
const LINK_ICONS = {
  LinkIcon,
  EmbedOutlineIcon,
  DynamicFormIcon,
  RssIcon,
  EmailIcon,
  PhoneIcon,
  TitleIcon,
  CarouselIcon,
  MinusIcon,
  GroupIcon,
  TextBoxOutlineIcon,
  CardAccountDetailsOutlineIcon,
  DonationIcon,
  RequestIcon,
  GridIcon,
  ShopIcon
};
export { LINK_ICONS };